var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2000,
    viewBox: "0 0 2000 2000",
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m461.33789-737.63867c-230.50606 0-421.33789 186.40896-421.33789 416v748c0 229.59104 190.83183 416 421.33789 416h1077.32421c230.5061 0 421.3379-186.40896 421.3379-416v-748c0-229.59104-190.8318-416-421.3379-416zm0 220h1077.32421c114.4556 0 201.3379 86.543 201.3379 196v748c0 109.45699-86.8823 196-201.3379 196h-1077.32421c-114.45558 0-201.33789-86.54301-201.33789-196v-748c0-109.457 86.88231-196 201.33789-196z",
    transform: "translate(0 947.63784)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallActivity);
export default __webpack_public_path__ + "static/media/call-activity.f2a43ddc6024586163b28198d27fd286.svg";
export { ForwardRef as ReactComponent };